export default "__VITE_ASSET__7$3rgCqj__"